const defaultCustomerData = {
  customerBirthday: '0000-00-00',
  customerCity: '',
  customerCompany: '',
  customerCountry: 'US',
  customerEmailAddress: '',
  customerFirstName: '',
  customerLastName: '',
  customerMgrUsername: '',
  customerPostcode: '',
  customerProvince: '',
  customerState: '',
  customerStreetAddress: '',
  customerSuburbAddress: '',
  customerTelephone: '',
  tokenNumber: '',
}

export default defaultCustomerData
